const ITEMS = ["Gyros", "Souvlaki", "Tzatziki", "Saganaki", "Bifteki", "Seit 1985", "Siegen", "Frisch & freundlich"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className="font-display px-10 text-2xl font-light italic tracking-tight text-[#1A1C19]/45 md:text-3xl">
          {t}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-[#78825B]/50" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="marquee" className="relative z-10 overflow-hidden border-y border-[#E2E0D8] bg-[#F0EFEA]/60 py-6">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
